import i18n from 'i18next'

export default () => [
  { slug: 'full_time', label: i18n.t('remote.full_time') },
  { slug: 'partial', label: i18n.t('remote.partial') },
  { slug: 'never', label: i18n.t('remote.never') }
]
